import BDWidget from '../Widget'
import DomUtil from '../../utils/DomUtil'
import CameraUtil from "../../utils/CameraUtil"
class LocationBar extends BDWidget {
    constructor() {
        super();
        this._lastMouseSampleTime = Cesium.getTimestamp()
        this._lastCameraSampleTime = Cesium.getTimestamp()
        this._lastFpsSampleTime = Cesium.getTimestamp()
        this._lastMsSampleTime = Cesium.getTimestamp()
        this._fpsFrameCount = 0
        this._msFrameCount = 0
    }

    getType() {
        return "locationBar"
    }

    mountContent() {
        this._wrapper = DomUtil.create('div', 'bd-location-bar');
        this._mouseEl = DomUtil.create('div', 'mouse-bar', this._wrapper)
        this._cameraEl = DomUtil.create('div', 'camera-bar', this._wrapper)
        this._msEl = DomUtil.create('div', 'ms-bar', this._wrapper)
        this._fpsEl = DomUtil.create('div', 'fps-bar', this._wrapper)
        this.hide();
    }

    updateContent() {
        let now = Cesium.getTimestamp()

        // ms
        this._msFrameCount++
        let msElapsedTime = now - this._lastMsSampleTime
        if (msElapsedTime > 200) {
            let ms = (msElapsedTime / this._msFrameCount).toFixed(2)
            this._msEl.innerHTML = `<span>${ms} MS</span>`
            this._lastMsSampleTime = now
            this._msFrameCount = 0
        }

        // fps
        this._fpsFrameCount++
        let fpsElapsedTime = now - this._lastFpsSampleTime
        if (fpsElapsedTime > 1000) {
            let fps = ((this._fpsFrameCount * 1000) / fpsElapsedTime) | 0
            this._fpsEl.innerHTML = `<span>${fps} FPS</span>`
            this._lastFpsSampleTime = now
            this._fpsFrameCount = 0
        }

    }


    //方法二
    tileLevel() {
        let tiles = new Set();
        let tilesToRender = this.viewer.scene.globe._surface._tilesToRender;
        if (Cesium.defined(tilesToRender)) {
            for (let i = 0; i < tilesToRender.length; i++) {
                tiles.add(tilesToRender[i].level);
            }
        }

        return tiles;
    }

    onCameraChanged() {

        if (!this._cameraUtil) {
            this._cameraUtil = new CameraUtil(this.viewer.camera);
        }

        var z = this.viewer.scene.globe._surface._debug.maxDepthVisited;
        // var zSet=this.tileLevel();
        // let z = zSet.values().next().value;

        let now = Cesium.getTimestamp()
        if (now < this._lastCameraSampleTime + 300) {
            return
        }
        let cameraPosition = this._cameraUtil.getCameraPosition();
        this._cameraEl.innerHTML = `
          <span>层级：${z}</span>
          <span>偏航角：${(+cameraPosition.heading).toFixed(2)}</span>
          <span>俯仰角：${(+cameraPosition.pitch).toFixed(2)}</span>
          <span>翻滚角：${(+cameraPosition.roll).toFixed(2)}</span>
          <span>视角高：${(+cameraPosition.alt).toFixed(2)} 米</span>
        `
        this._lastCameraSampleTime = now

    }

    mouseMoveHandler(movement) {

        if (!movement.endPosition) {
            return false
        }

        let now = Cesium.getTimestamp()
        if (now < this._lastMouseSampleTime + 300) {
            return
        }
        var position = this.getMouseInfo(movement.endPosition);
        this._mouseEl.innerHTML = `
        <span>经度：${position.lng.toFixed(8) || Number.NaN}</span>
        <span>纬度：${position.lat.toFixed(8) || Number.NaN}</span>
        <span>海拔：${position.alt.toFixed(2) || Number.NaN} 米</span>`
        this._lastMouseSampleTime = now;

    }

    getMouseInfo(position) {
        let scene = this.viewer.scene
        let surfaceCartesian = undefined
        let wgs84SurfacePosition = undefined
        if (
            scene.mode === Cesium.SceneMode.SCENE3D &&
            !(this.viewer.terrainProvider instanceof Cesium.EllipsoidTerrainProvider)
        ) {
            let ray = scene.camera.getPickRay(position)
            surfaceCartesian = scene.globe.pick(ray, scene)
        } else {
            surfaceCartesian = scene.camera.pickEllipsoid(
                position,
                Cesium.Ellipsoid.WGS84
            )
        }
        if (surfaceCartesian) {
            let c = Cesium.Ellipsoid.WGS84.cartesianToCartographic(surfaceCartesian)
            if (c) {
                wgs84SurfacePosition = {
                    lng: Cesium.Math.toDegrees(c.longitude),
                    lat: Cesium.Math.toDegrees(c.latitude),
                    alt: c.height
                }
            }
        }
        return wgs84SurfacePosition || { lng: 0, lat: 0, alt: 0 };
    }


    bindEvent() {
        this.handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas)
        this.viewer.scene.postUpdate.addEventListener(this.updateContent, this);
        this.viewer.camera.changed.addEventListener(this.onCameraChanged, this)
        this.handler.setInputAction((e) => this.mouseMoveHandler(e), Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        this.viewer.container.appendChild(this._wrapper);
        this.show();
    }

    unbindEvent() {

        this.viewer.scene.postUpdate.removeEventListener(this.updateContent, this);
        this.viewer.camera.changed.removeEventListener(this.onCameraChanged, this)
        this.handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE)
        this.viewer.container.removeChild(this._wrapper);
        this.hide();

    }


}

export default LocationBar;